// extracted by mini-css-extract-plugin
export default {"radioButtons":"rater-card_radioButtons__Wu33F","card":"rater-card_card__9f1tw","fade":"rater-card_fade__s-PBa"};